import React, { Component } from "react";
import RightSidePannel from "../rightSidePannelReusable/RightSidePannel";
import Alert from "react-s-alert";
import { TopTextReusableComponent } from "../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  NewInputText,
  // TextAreaReusableComponent,
} from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import Form from "react-bootstrap/Form";
import {
  ReusableOnboardingButton,
  ReusableOnboardingMapButton,
} from "../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import SuggestNewButton from "../../reusableOnboardingPopupComponent/suggestNew/SuggestNewButton";
import isEmpty from "../../../../store/validation/is-Empty";
import { create_and_update_restaurant } from "../../../../store/actions/authAction";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { SliderReusableComponent } from "../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { BackLogoIconButton } from "../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { MobileTopHeader } from "../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import Media from "react-media";

export class ParkingMethodOnboarding extends Component {
  constructor(props) {
    super(props);
    this.state = {
      actionButton: false,
      loader: false,
      healthdata: false,
      selectedPage: 6,
      selectedTab: 2,
      parking_desc: "",
      all_parkings: [],
      selected_parking_type: [],
      primary_parking_type: {},
      errors: [],
    };
  }

  componentDidMount() {
    if (this.props.auth.loader) {
      this.setState({
        loader: true,
      });
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    // console.log(nextProps.parking_type);
    if (
      !isEmpty(nextProps.onboarding._id) &&
      !isEmpty(nextProps.parking_type) &&
      !nextState.hasSetMapProps
    ) {
      let selected_parking_type = nextProps.onboarding.selected_parking_type;
      let primary_parking_type = nextProps.onboarding.primary_parking_type;
      if (
        !isEmpty(nextProps.onboarding.primary_parking_type) &&
        !isEmpty(selected_parking_type[0])
      ) {
        if (
          nextProps.onboarding.primary_parking_type !== "" &&
          isEmpty(selected_parking_type[0]._id) &&
          selected_parking_type.length > 0 &&
          isEmpty(primary_parking_type._id)
        ) {
          selected_parking_type = nextProps.parking_type.filter((parking) =>
            selected_parking_type.includes(parking._id)
          );
          primary_parking_type = nextProps.parking_type.filter(
            (parking) => parking._id === primary_parking_type
          )[0];
        }
      }
      let all_parking_type = nextProps.parking_type.filter(
        (parking) =>
          !selected_parking_type.some(
            (selected) => selected._id === parking._id
          ) && parking.status !== "NOTAPPROVED"
      );
      return {
        all_parkings: all_parking_type,
        selected_parking_type: !isEmpty(selected_parking_type)
          ? selected_parking_type
          : [],
        primary_parking_type: !isEmpty(primary_parking_type)
          ? primary_parking_type
          : {},
        hasSetMapProps: true,
        parking_desc: nextProps.onboarding.parking_desc,
        selectedPage: nextProps.onboarding.selectedPage,
      };
    }
    if (nextProps.auth.loader !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
      };
    }
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextProps.errors,
      };
    }
    return null;
  }

  onChange = (e) => {
    // this.setState({
    //   [e.target.name]: e.target.value,
    //   actionButton: true,
    // });
    let caps = e.target.value;
    caps = caps.charAt(0).toUpperCase() + caps.slice(1);
    let dataSet = caps;
    this.setState({
      [e.target.name]: dataSet,
      actionButton: true,
    });
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[e.target.name] = `${e.target.name} is required`;
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
      actionButton: true,
    });
  };

  /********************************
   * @DESC Back Button
   ********************************/
  onBackButton = (history) => (e) => {
    e.preventDefault();
    // const formData = {
    //   vendor_id: this.props.auth.user.VendorUser._id,
    //   id: this.props.onboarding._id,
    //   selectedPage: 6,
    // };
    // this.props.create_and_update_restaurant(formData);
    history.push("/paymenttype");
  };

  /****************************************
   * @DESC - Payment Method SELECTOR
   ****************************************/
  onRestaurantSelectorArraySelector = (icon, index) => (e) => {
    let buttonArray = this.state.all_parkings;
    let Restaurant = this.state.selected_parking_type;
    let primaryIcon = this.state.primary_parking_type;
    if (icon.title === "No Parking" && Restaurant.length >= 1) {
      Alert.error("<h4>Cannot select this option</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 5000,
        offset: 30,
      });
    } else if (primaryIcon.title == "No Parking") {
      Alert.error("<h4>No Parking Already Selected", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 5000,
        offset: 30,
      });
    } else {
      buttonArray.splice(index, 1);
      if (Restaurant.length === 0 || primaryIcon === {}) {
        Restaurant.push(icon);
        this.setState({
          selected_parking_type: Restaurant,
          primary_parking_type: icon,
          actionButton: true,
        });
      } else {
        let isAlreadyPresent = Restaurant.includes(icon);
        if (isAlreadyPresent) {
          let indexOf = Restaurant.indexOf(icon);
          if (indexOf === 0 || indexOf) {
            Restaurant.splice(indexOf, 1);
          }
        } else {
          Restaurant.push(icon);
        }
      }
      this.setState({
        selected_parking_type: Restaurant,
        actionButton: true,
      });
    }
  };

  onRestaurantsPrimarySelector = (icon) => (e) => {
    this.setState({
      primary_parking_type: icon,
      actionButton: true,
    });
  };

  /****************************************
   * @DESC - Remove Primary button handler
   ****************************************/
  removeButton = (icon) => (e) => {
    let { all_parkings, selected_parking_type, primary_parking_type } =
      this.state;

    let iconIndexAtAllIcons = all_parkings.findIndex(
      (icons) => icons._id === icon._id
    );
    let iconIndexAtSelectedIcons = selected_parking_type.findIndex(
      (icons) => icons._id === icon._id
    );
    let iconAtPrimaryIcon =
      !isEmpty(primary_parking_type) && primary_parking_type._id === icon._id
        ? true
        : false;
    if (selected_parking_type.length === 0) {
      selected_parking_type.push(icon);
      all_parkings.splice(iconIndexAtAllIcons, 1);
      primary_parking_type = icon;
    } else if (iconAtPrimaryIcon) {
      selected_parking_type.splice(iconIndexAtSelectedIcons, 1);
      all_parkings.push(icon);
      if (selected_parking_type.length === 1) {
        primary_parking_type = selected_parking_type[0];
      } else {
        primary_parking_type = {};
      }
    } else if (iconIndexAtSelectedIcons === 0 || iconIndexAtSelectedIcons) {
      selected_parking_type.splice(iconIndexAtSelectedIcons, 1);
      all_parkings.push(icon);
      if (selected_parking_type.length === 1) {
        primary_parking_type = selected_parking_type[0];
      }
    } else {
      selected_parking_type.push(icon);
      all_parkings.splice(iconIndexAtAllIcons, 1);
    }

    this.setState({
      selected_parking_type: selected_parking_type,
      all_parkings: all_parkings,
      primary_parking_type: primary_parking_type,
      actionButton: true,
    });
  };

  onWithOutApiCall = (e) => {
    this.props.history.push({
      pathname: "/petsallowed",
    });
  };

  onHandleSubmit = (e) => {
    e.preventDefault();
    if (
      this.props.onboarding &&
      this.props.onboarding.selected_parking_type.length > 0
    ) {
      const formData = {
        vendor_id: this.props.onboarding.vendor_id,
        id: this.props.onboarding._id,
        selected_parking_type: this.state.selected_parking_type,
        primary_parking_type: this.state.primary_parking_type,
        parking_desc: this.state.parking_desc,
      };
      this.props.create_and_update_restaurant(formData);
      this.props.history.push("/petsallowed");
    } else {
      const formData = {
        vendor_id: this.props.onboarding.vendor_id,
        id: this.props.onboarding._id,
        selected_parking_type: this.state.selected_parking_type,
        primary_parking_type: this.state.primary_parking_type,
        parking_desc: this.state.parking_desc,
        page_completed_till: 8,
      };
      this.props.create_and_update_restaurant(formData);
      this.props.history.push("/petsallowed");
    }
  };

  renderParkingMethodFields = () => {
    const {
      actionButton,
      errors,
      selected_parking_type,
      primary_parking_type,
      parking_desc,
    } = this.state;
    return (
      <React.Fragment>
        <div className="restaurant_type_onboarding_main">
          <div className="margin-bottom-chains-onboarding">
            <div className="cuisine-main ">
              <div
                className={
                  this.state.all_parkings.length > 8
                    ? "cuisine-main-padding-border"
                    : ""
                }
              >
                <div
                  id="box-style"
                  className="cuisine-main-padding column-2 justify-content-start"
                  style={{ display: "flex", flexWrap: "wrap" }}
                >
                  {this.state.all_parkings.map((icon, index) => (
                    <ReusableOnboardingMapButton
                      key={index}
                      classsection="onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                      src={icon.icon}
                      title={icon.title}
                      onClick={this.onRestaurantSelectorArraySelector(
                        icon,
                        index
                      )}
                    />
                  ))}
                </div>
              </div>
              <div className="suggest-button-heading">
                <SuggestNewButton categoryId={"5f562c9094ac7fdf47ea1d15"} />
              </div>

              {/** */}
              {!isEmpty(selected_parking_type) ? (
                <React.Fragment>
                  <div className="f14-500 mt-4">
                    Out of the selections below, which one is primary?
                  </div>
                  <div className="f11-400 opacity5">
                    Select only one of the options below as a default - this is
                    shown to the user.
                  </div>
                </React.Fragment>
              ) : null}

              <div
                className="cuisine-main-padding-bottom column-2 justify-content-start mt-4"
                style={{ display: "flex", flexWrap: "wrap" }}
              >
                {selected_parking_type.map((icon, index) => (
                  <ReusableOnboardingMapButton
                    key={index}
                    classsection={
                      // icon._id === primary_parking_type._id
                      //   ?
                      "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_active_two onboarding_mapbutton_reusable_type"
                      // : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_active"
                    }
                    src={icon.icon}
                    title={icon.title}
                    onClick={this.onRestaurantsPrimarySelector(icon)}
                    displayPrimary={
                      icon._id === primary_parking_type._id ? true : false
                    }
                    displayRemove={true}
                    removeButtonClick={this.removeButton(icon)}
                  />
                ))}
              </div>
            </div>
            <div className="col-12 p-0 parking-method-mobile-bottom mb-md-5 mb-lg-5 mb-xl-5 text-area-labelText-padding">
              {/* <TextAreaReusableComponent
                controlId="parking_desc"
                displayText={true}
                labelText="Description For Parking And Accessibility"
                labelSmall="( If you provide free , valet or validated parking let users know here )"
                labelTextClass="text-area-lable"
                placeholder="eg. if you buy for rs. 1000 you get free parking"
                rows="4"
                onChange={this.onChange}
                onFocusOut={this.onFocusOut}
                name="parking_desc"
                value={this.state.parking_desc}
                inputClassName={classnames("input-text-area text-area-new", {
                  invalid: errors.parking_desc,
                })}
                error={
                  this.state.parking_desc <= 0
                    ? errors.parking_desc === "parking_desc is required"
                      ? "parking desc is required"
                      : null
                    : null
                }
              /> */}
              {/* <div className="col-12 p-0 text-area-labelText-padding"> */}
              <NewInputText
                extraClass="text-area-labelText-padding-two mt-3"
                name="parking_desc"
                onChange={this.onChange}
                // onFocusOut={this.onFocusOut}
                rows="4"
                multiline={true}
                value={this.state.parking_desc}
                // errorText={
                //   errors.parking_desc === "parking_desc is required"
                //     ? "parking description is required"
                //     : ""
                // }
                // errorTrue={
                //   errors.parking_desc === "parking_desc is required"
                //     ? true
                //     : false
                // }
                labelText="Description For Parking And Accessibility"
                helpTextDisplay={true}
                helperTextBottom="( If you provide free , valet or validated parking let users know here )"
                controlClass={
                  // errors.parking_desc === "parking_desc is required"
                  //   ? "outlined-error-helper-text"
                  //   :
                  "outlined-helperText "
                }
              />
            </div>
          </div>
          <div className="onboarding-map-setup-screen-autodetect-button">
            {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}
            <ReusableOnboardingButton
              buttonTitle="Back Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
              buttonText="Back"
              buttonType="button"
              onClick={this.onBackButton(this.props.history)}
            />
            <ReusableOnboardingButton
              buttonTitle="Next Button"
              buttonClass={
                selected_parking_type.length <= 0 ||
                // parking_desc === "" ||
                // parking_desc === undefined ||
                isEmpty(primary_parking_type)
                  ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray ml-3"
                  : "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
              }
              disabled={
                selected_parking_type.length <= 0 ||
                // parking_desc === "" ||
                // parking_desc === undefined ||
                isEmpty(primary_parking_type)
                  ? true
                  : false
              }
              buttonText="Next"
              onClick={actionButton === false ? this.onWithOutApiCall : null}
              buttonType={actionButton === false ? "button" : "submit"}
            />
            {/* </div> */}
          </div>
        </div>
      </React.Fragment>
    );
  };

  render() {
    if (this.state.loader) {
      return <AmealioLoader />;
    }
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div
              id="onboarding-scrollbar"
              className="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left"
            >
              <div className="col-12 onboarding_process_screen_left-backbutton">
                {/* <div
                  onClick={this.onBackButton(this.props.history)}
                  className="back_button-link"
                >
                  <Image
                    src={require("../../../../assets/images/Icon/onBoardBack.png")}
                    alt="Back Button"
                    title="Back Button"
                  />
                </div> */}

                <Media query="(min-width: 992px)">
                  <div className="col-12">
                    <BackLogoIconButton
                      displayBackText={true}
                      displayArrow={true}
                      workWithLinkORClick={true}
                      backButtonClicked={this.onBackButton(this.props.history)}
                    />
                  </div>
                </Media>
                <Media query="(max-width: 991px)">
                  <MobileTopHeader
                    onClick={this.onBackButton(this.props.history)}
                  />
                </Media>
              </div>
              {/* <div className="display-toggle-stepup-button">
                <RightSidePannel selectedTab={this.state.selectedTab} />
              </div> */}
              <div className="onboarding_process_screen-button-map">
                {/* <MapSetupScreenTwo /> */}
                <div>
                  <TopTextReusableComponent
                    headingText="Parking"
                    headingParagraph="Select the payment types accepted at your facility"
                  />
                </div>
                <Form noValidate onSubmit={this.onHandleSubmit}>
                  {this.renderParkingMethodFields()}
                </Form>
              </div>
            </div>
            <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
              <SliderReusableComponent
                displayBarButton={true}
                displayHamburger={true}
                selectedProgressBarOne="active"
                paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                bottomImage={require("../../../../assets/images/illustratorImage/Amealio_Illustrations-06.svg")}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

ParkingMethodOnboarding.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  parking_type: state.category.parking_type,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  create_and_update_restaurant,
})(withRouter(ParkingMethodOnboarding));
